import React from "react";
import {
  CContainer,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";
import UserTaxPayer from "../../models/user-tax-payer";
import UserTaxPayerForm from "./UserTaxPayerForm";

interface UserTaxPayerUpdateModalProps {
  show: boolean;
  userTaxPayer?: UserTaxPayer;
  taxPayerId?: number;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const UserTaxPayerUpdateModal: React.FC<UserTaxPayerUpdateModalProps> = ({
  show,
  userTaxPayer,
  taxPayerId,
  onCancel,
  onSuccess,
}) => {
  const modalTitle = userTaxPayer
    ? `Editar Usuario de Contribuyente: ${userTaxPayer.user?.email}`
    : `Agregar Usuario a Contribuyente`;

  const onClose = () => {
    onCancel();
  };

  return (
    <CModal show={show} onClose={onClose} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>{modalTitle}</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          {show ? (
            <UserTaxPayerForm
              userTaxPayer={userTaxPayer}
              taxPayerId={taxPayerId}
              onCancel={onCancel}
              onSuccess={onSuccess}
              clearOnSuccess={false}
            />
          ) : (
            <></>
          )}
        </CContainer>
      </CModalBody>
    </CModal>
  );
};

export default UserTaxPayerUpdateModal;
